<template>
    <div v-if="$store.state.connected">
        <h1>Rapport</h1>
        <ReportExport/>
    </div>
</template>

<script>
    import ReportExport from "@/components/Report/ReportExport.vue";
    import router from "../router/index.js";
    
    export default {
        name: "Report",
        components: {
            ReportExport,
        },
        data(){
            return{
            }
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>
<style>
    .editForm{
        width: 40%;
    }

    h1{ margin-top: 0.3em; }
    @media screen and (max-width: 980px){
        .editForm{
            width: 90% !important;
        }
    }
</style>